import styled from 'styled-components';
import { CFBaseModalVeilStyles, CFStyleThemes, } from '@connectrn/ds-ui-base';
export const CFModalVeilElements = {
    Hitspace: styled.button `
    ${CFBaseModalVeilStyles.Hitspace}
  `,
    Root: styled.div `
    ${CFBaseModalVeilStyles.Root};
    ${CFBaseModalVeilStyles.RootWithCSSTransition};
  `,
};
CFModalVeilElements.Root.defaultProps = {
    theme: CFStyleThemes.DEFAULT,
};
